var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoPhotioMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 12,
    viewBox: "0 0 94 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_18009)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 11.5879,
    transform: "translate(0 0.206055)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.88126 3.13602H5.7624V6.01703H2.88126V3.13602ZM2.88126 8.89816H0V11.7793H2.88126V8.89816ZM2.88126 8.89816H8.64328V0.254888H0V6.01715H2.88126V8.89816Z",
    fill: "#002061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2354 5.24211H33.6774V0.206154H32.1636V11.7921H33.6774V6.75603H42.2354V11.7921H43.7493V0.206154H42.2354V5.24211Z",
    fill: "#002061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4937 11.7921H79.0076V0.206149H77.4937V11.7921Z",
    fill: "#002061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1323 10.2779C50.7728 10.2779 48.8533 8.35846 48.8533 5.99908C48.8533 3.63969 50.7728 1.72009 53.1323 1.72009C55.4919 1.72009 57.4114 3.63969 57.4114 5.99908C57.4113 8.35846 55.4919 10.2779 53.1323 10.2779ZM53.1324 0.206159C49.938 0.206159 47.3394 2.80484 47.3394 5.99908C47.3394 9.19344 49.938 11.792 53.1323 11.792C56.3268 11.792 58.9253 9.19344 58.9253 5.99908C58.9253 2.80484 56.3268 0.206159 53.1324 0.206159Z",
    fill: "#002061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.207 10.2781C85.8475 10.2781 83.928 8.35846 83.928 5.99908C83.928 3.63969 85.8475 1.72009 88.207 1.72009C90.5666 1.72009 92.486 3.63969 92.486 5.99908C92.486 8.35846 90.5665 10.2781 88.207 10.2781ZM88.207 0.206159C85.0126 0.206159 82.4141 2.80484 82.4141 5.99908C82.4141 9.19344 85.0126 11.792 88.207 11.792C91.4013 11.792 93.9999 9.19344 93.9999 5.99908C93.9999 2.80484 91.4013 0.206159 88.207 0.206159Z",
    fill: "#002061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1643 0.801713C26.6104 0.412122 25.9603 0.206154 25.2842 0.206154H16.9731V1.72008H25.2842C26.2551 1.72008 27.0451 2.51012 27.0451 3.48109C27.0451 4.45207 26.2551 5.24211 25.2842 5.24211H16.9731V11.7921H18.4872V6.75603H25.2842C25.9604 6.75603 26.6106 6.55007 27.1643 6.16047C27.4755 5.94161 27.7443 5.67281 27.9635 5.36137C28.3531 4.80757 28.5591 4.15736 28.5591 3.48109C28.5591 2.80496 28.3531 2.15475 27.9635 1.60082C27.7444 1.2895 27.4756 1.02071 27.1643 0.801713Z",
    fill: "#002061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3423 1.72021H67.3782V11.7921H68.8923V1.72021H73.9281V0.206154H62.3423V1.72021Z",
    fill: "#002061"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_18009"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 11.5879,
    fill: "white",
    transform: "translate(0 0.206055)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPhotioMobile);
export default __webpack_public_path__ + "static/media/LogoPhotioMobile.941e86eec0df82a67c809454eb3bcad1.svg";
export { ForwardRef as ReactComponent };